var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_157_195",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2085 5.2085H44.7918V44.7918H5.2085V5.2085Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_157_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7293 5.50008L27.5418 5.33341C23.9729 4.81812 20.3311 5.3279 17.0409 6.80334C13.7506 8.27878 10.9476 10.6591 8.9585 13.6667C6.84215 16.5417 5.58055 19.9558 5.31887 23.5161C5.05719 27.0764 5.80607 30.6383 7.47933 33.7917C7.65057 34.1078 7.75719 34.4548 7.79296 34.8125C7.82872 35.1701 7.79293 35.5314 7.68766 35.8751C6.8335 38.8126 6.04183 41.7709 5.2085 44.8751L6.25016 44.5626C9.06266 43.8126 11.8752 43.0626 14.6877 42.3751C15.2813 42.2517 15.8983 42.3097 16.4585 42.5418C18.9818 43.7733 21.7394 44.4508 24.5461 44.5288C27.3528 44.6069 30.1438 44.0837 32.7316 42.9943C35.3195 41.905 37.6444 40.2747 39.5504 38.2128C41.4563 36.151 42.8992 33.7053 43.7821 31.04C44.6651 28.3746 44.9677 25.5512 44.6697 22.7593C44.3717 19.9673 43.4799 17.2714 42.0542 14.8525C40.6285 12.4336 38.7019 10.3476 36.4037 8.73451C34.1055 7.12144 31.4888 6.01863 28.7293 5.50008ZM33.9793 32.8334C33.2222 33.5113 32.2988 33.9764 31.3034 34.1814C30.308 34.3863 29.276 34.3237 28.3127 34.0001C23.9472 32.7708 20.1598 30.0318 17.6252 26.2709C16.657 24.9408 15.8787 23.4823 15.3127 21.9376C15.0061 21.0413 14.9508 20.0781 15.1528 19.1527C15.3548 18.2272 15.8064 17.3746 16.4585 16.6876C16.776 16.2824 17.2081 15.9822 17.6986 15.8262C18.1891 15.6701 18.7153 15.6654 19.2085 15.8126C19.6252 15.9167 19.9168 16.5209 20.2918 16.9792C20.596 17.8397 20.9522 18.6813 21.3543 19.5001C21.6594 19.9178 21.7868 20.4392 21.7087 20.9506C21.6307 21.4619 21.3535 21.9216 20.9377 22.2292C20.0002 23.0626 20.146 23.7501 20.8127 24.6876C22.2865 26.8108 24.3202 28.4839 26.6877 29.5209C27.3543 29.8126 27.8543 29.8751 28.2918 29.1876C28.4793 28.9167 28.7293 28.6876 28.9377 28.4376C30.146 26.9167 29.771 26.9376 31.6877 27.7709C32.2981 28.0272 32.8897 28.3272 33.4585 28.6667C34.021 29.0001 34.8752 29.3542 35.0002 29.8542C35.1204 30.3967 35.0888 30.9618 34.9087 31.4874C34.7286 32.013 34.407 32.4787 33.9793 32.8334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.014b93427047149506ee83b2f001aae5.svg";
export { ForwardRef as ReactComponent };